import * as React from 'react';
import { ReactNode } from 'react';
import { TreeRecord } from '../types';
import { TreeContext } from './TreeContext';
import { UseTreeControllerResult } from './useTreeController';

export const TreeContextProvider = <
    RecordType extends TreeRecord = TreeRecord
>({
    children,
    value,
}: TreeContextProviderProps<RecordType>) => (
    <TreeContext.Provider value={value}>{children}</TreeContext.Provider>
);

export interface TreeContextProviderProps<
    RecordType extends TreeRecord = TreeRecord
> {
    children: ReactNode;
    value: UseTreeControllerResult<RecordType>;
}
